module.exports = __webpack_public_path__ + "img/duPontAnalysis1.5e6606bb.png";